import React from "react";
export default function MA() {
  return <div>MA</div>;
}
